import React, {Component} from "react";
import {
    Panel,
    Modal,
    ProgressBar,
    FormGroup,
    ControlLabel,
    FormControl,
    InputGroup,
    Button,
    Row,
    Col
}                         from "react-bootstrap";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";
import Select             from "react-select";
import                          "react-select/dist/react-select.css";
import axios              from "axios";
import FileSaver          from 'file-saver';
import socketIOClient     from "socket.io-client";
import {
	ToastContainer,
	toast
}                         from "react-toastify";
import moment             from "moment";

import {
    IS_VALID
}                         from "utils";

import CrudComponent      from "../zynappse-crud";
import
MobilePOSScanLogSchema    from "./MobilePOSScanLog";
import saveTrail          from "utils/saveTrail";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class MobilePOSScanLog extends Component {
    constructor (props) {
        super(props);

        this.refreshTableReference;

        this.exportData = this.exportData.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.loadOptions = this.loadOptions.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.accessible = this.accessible.bind(this);
    }

    exportData () {
        let {
            MobilePOSScanLog,
            actions
        } = this.props;

        let {
            memberId,
            startDate,
			endDate
        } = MobilePOSScanLog;

        if (!IS_VALID(startDate)) {
			toast.error("Start Date is required.");
		} else if (!moment(startDate).isValid()) {
			toast.error("Please select a valid Start Date.");
		} else if (!IS_VALID(endDate)) {
			toast.error("End Date is required.");
		} else if (!moment(endDate).isValid()) {
			toast.error("Please select a valid End Date ");
		} else {
            actions.setValue({
                isExportStarting: true
            });
    
            let fd = new FormData();

            fd.append("startDate", moment(startDate).startOf("day").format());
            fd.append("endDate", moment(endDate).endOf("day").format());
                
            if (
                Array.isArray(memberId) &&
                memberId.length !== 0
            ) {
                for (let index = 0; index < memberId.length; index++) {
                    let item = memberId[index];
                    
                    fd.append(`memberIdArray[${index}]`, item.value);
                }
            }

            axios.post(
                WEB_PATH + "/MobilePOSScanLog/export",
                fd,
                {
                    timeout: 30000
                }
            )
            .then((res) => {
                let {
					fileName,
					socketNspId
				} = res.data;
				  
				actions.setValue({
					isExportStarting: false,
					isExporting: true
                });
                
                let io = socketIOClient(
					WEB_PATH,
					{
					  transports: ["websocket"],
					  path: "/socket.io",
					  query: {
						nspId: socketNspId
					  },
					  secure: true
					}
                );
                
                io.on(
					"export-scan-logs-socket",
					(data) => {
						let {
							status,
							progress,
							fileName,
							message
						} = data;
		  
						if (status === "PROGRESS") {
							actions.setValue({
								exportPercentage: progress
							});
						} else if (status === "DONE") {
							actions.setValue({
								exportPercentage: 100
							});
			
							io.off("export-scan-logs-socket");
							io.close();
							
							axios.get(
								WEB_PATH + '/MobilePOSScanLog/download/' + fileName,
								{
									responseType: "arraybuffer"
								}
							)
							.then((res2) => {
								let blob = new Blob([res2.data], { type: "application/vnd.ms-excel" }),
									filename = `QR Code Scan log ${moment().format("MMM DD YYYY hh:mm A")}.xlsx`;
				
                                    actions.setValue({
									isExporting: false,
									isExportSuccess: true,
									exportPercentage: 100,
									fileConfig: {
										filename: filename,
										blob: blob
									}
								});
				
								FileSaver.saveAs(blob, filename);
							})
							.catch((err) => {
								let errorMessage = err.message;
				
								if (
									err.response &&
									err.response.data &&
									("TextDecoder" in window)
								) {
									let enc = new TextDecoder("utf-8");
									let arr = new Uint8Array(err.response.data);
									
									let data = JSON.parse(enc.decode(arr)) || {};
				
									if (
										data.error &&
										data.error.message
									) {
										errorMessage = data.error.message;
									}
								}
								
								actions.setValue({
									isExporting: false,
									isExportError: true,
									errorMessage
								});
							});
						} else if (status === "ERROR") {
							io.off("export-scan-logs-socket");
							io.close();
							
							actions.setValue({
								isExporting: false,
								isExportError: true,
								errorMessage: message
							});
						}
					}
				);
            })
            .catch((err) => {
                let errorMessage = err.message;

				if (
				  err.response &&
				  err.response.data &&
				  typeof err.response.data === "string"
				) {
				  errorMessage = err.response.data;
				}
		
				actions.setValue({
				  isExportStarting: false,
				  isExportError: true,
				  errorMessage
				});
            });
        }
    }

    downloadFile () {
        let {
            fileConfig
        } = this.props.MobilePOSScanLog;
        
        FileSaver.saveAs(fileConfig.blob, fileConfig.filename)
    }

    refreshTable () {
        if (
            IS_VALID(IS_VALID) &&
            typeof this.refreshTableReference === "function"
        ) {
            this.refreshTableReference();
        }
    }

    loadOptions (input, cb) {
        let query = new Parse.Query("MemberDetail");

        query
        .matches("memberId", input, "i")
        .exists("memberId")
        .notEqualTo("memberId", "")
        .ascending("memberId")
        .limit(20);

        query.find()
        .then((data) => {
            cb(
                null,
                {
                    options: data.map((item) => ({
                        label: item.get("memberId"),
                        value: item.get("memberId")
                    }))
                }
            );
        })
        .catch((err) => {
            cb(null, { options: [] });
        });
    }

    renderModalButton () {

    }

    accessible (actionType) {
        let {
            access
        } = this.props.accessjson;

        if (access.length !== 0) {
			var currentPath = window.location.pathname,
                index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
                actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	            return 'none';
	        }
		} else {
			return 'none';
		}
    }

    render () {
        let {
            MobilePOSScanLog,
            accessjson,
            actions
        } = this.props;

        let {
            showModalExport,
            isExportStarting,
            isExporting,
            isExportSuccess,
            isExportError,
            exportPercentage,
            fileConfig,
            errorMessage,

            memberId,
            startDate,
            endDate
        } = MobilePOSScanLog;     
          
        let {
            access
        } = accessjson;

        let crudProps = {
            schema: MobilePOSScanLogSchema,
            refreshTable: (refreshTable) => {this.refreshTableReference = refreshTable;},
            moduleQuery: [
                { method: "descending", column: "createdAt" }
            ],
            access: access,
            additionalButtons: []
        };

        if (this.accessible("EXPORT") === "") {
            crudProps.additionalButtons.push({
                label: "EXPORT",
                func: ({ filter, query }) => {
                    actions.setValue({
                        showModalExport: true
                    });
                },
                loaderState: false,
                disabledState: false
            });
        }

        let exportFilterFormprops = {
            actions,
            loadOptions: this.loadOptions,

            memberId,
            startDate,
            endDate
        };

        return (
            <div>
                <Panel>
                    <Panel.Heading
                        style={{
                            backgroundColor: '#D1282F',
                            color: 'white'
                        }}
                    >
                        <h4>{MobilePOSScanLogSchema.classNameLabel.toUpperCase()}</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <CrudComponent {...crudProps} />
                    </Panel.Body>
                </Panel>
                <ToastContainer />
                <Modal
                    bsSize={null}
                    backdrop="static"
                    show={showModalExport}
                    onHide={() => {
                        if (
                            !isExportStarting ||
                            isExporting
                        ) {
                            actions.setValue({
                                showModalExport: false,

                                isExportStarting: false,
                                isExporting: false,
                                isExportSuccess: false,
                                isExportError: false,
                                exportPercentage: 0,
                                fileConfig: {
                                    filename: "",
                                    blob: ""
                                },
                                errorMessage: "",

                                memberId: [],
                                startDate: "",
                                endDate: ""
                            });
                        }
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>EXPORT QR CODE SCAN LOG</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {!isExporting && !isExportSuccess && !isExportError ? (
                            isExportStarting ? (
                                <div style={{ textAlign: "center" }}>
                                    <i className="fa fa-spinner fa-spin fa-4x"></i>
                                    <h3>Loading</h3>
                                </div>
                            ): (
                                [
                                    <ExportFilterForm {...exportFilterFormprops} />,
                                    <div
                                        style={{ textAlign: "center" }}
                                    >
                                        <Button
                                            bsStyle="primary"
                                            onClick={() => this.exportData()}
                                        >
                                            EXPORT
                                        </Button>
                                    </div>
                                ]
                            )
                        ) : (
                            ""
                        )}
                        {
                            isExporting ? (
                                [
                                    <p>This may take some time depending on the number of records.</p>,
                                    <ProgressBar
                                    active
                                    striped
                                    bsStyle="success"
                                    now={exportPercentage}
                                    label={`${exportPercentage}%`}
                                    />
                                ]
                            ) : isExportSuccess || isExportError ? (
                                isExportSuccess ? (
                                    <div style={{ textAlign: "center" }}>
                                        <Button
                                            bsStyle="success"
                                            content="DOWNLOAD FILE"
                                            onClick={this.downloadFile}
                                        >
                                            DOWNLOAD FILE
                                        </Button>
                                    </div>
                                ) : (
                                    [
                                        <h3 style={{ textAlign: "center", color: "red" }}>Something went wrong.</h3>,
                                        <h4>{errorMessage}</h4>,
                                        <div style={{ textAlign: "center" }}>
                                            <Button
                                                bsStyle="primary"
                                                onClick={() => {
                                                    actions.setValue({
                                                        showModalExport: false,

                                                        isExportStarting: false,
                                                        isExporting: false,
                                                        isExportSuccess: false,
                                                        isExportError: false,
                                                        exportPercentage: 0,
                                                        fileConfig: {
                                                            filename: "",
                                                            blob: ""
                                                        },
                                                        errorMessage: "",

                                                        memberId: [],
                                                        startDate: "",
                                                        endDate: ""
                                                    });
                                                }}
                                                >
                                                CLOSE
                                            </Button>
                                        </div>
                                    ]
                                )
                            ) : (
                                ""
                            )
                        }
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

class ExportFilterForm extends Component {
    render () {
        let {
            actions,
            loadOptions,

            memberId,
            startDate,
            endDate
        } = this.props;

        return (
            <form>
                <Row>
                    <Col
                        md={8}
                        mdOffset={2}
                    >
                        <FormGroup>
                            <ControlLabel>Member ID</ControlLabel>
                            <Select.Async
                                multi={true}
                                placeholder="Select or search..."
                                loadOptions={(input, cb) => loadOptions(input, cb)}
                                value={memberId}
                                onChange={(value) => {
                                    actions.setValue({
                                        memberId: value
                                    });
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Date</ControlLabel>
                            <InputGroup>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat={false}
                                    value={startDate}
                                    onChange={(date) => {
                                        actions.setValue({
                                            startDate: date
                                        });
                                    }}
                                    inputProps={{
                                        placeholder: "Start Date",
                                        style: {
                                            position: "initial",
                                            borderRadius: "4px 0 0 4px"
                                        }
                                    }}
                                />
                                <InputGroup.Addon>TO</InputGroup.Addon>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat={false}
                                    value={endDate}
                                    onChange={(date) => {
                                        actions.setValue({
                                            endDate: date
                                        });
                                    }}
                                    inputProps={{
                                        placeholder: "End Date",
                                        style: {
                                            position: "initial",
                                            borderRadius: "0 4px 4px 0"
                                        }
                                    }}
                                />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
            </form>
        );
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
    MOBILE_POS_SCAN_LOG
}                           from "actions/const";

function mapStateToProps(state) {
	var {
        accessjson,
        MobilePOSScanLog
	} = state;

	const props = {
        accessjson,
        MobilePOSScanLog
	};
	return props;
}

function mapDispatchToProps(dispatch) {
    const actions = {
      setValue: (stateObject, actionType = MOBILE_POS_SCAN_LOG) => generics.setValue(actionType, stateObject)
    };
  
    return {
      actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MobilePOSScanLog);


// WEBPACK FOOTER //
// ./components/MobilePOSScanLog/index.js